import authService from './auth';
import {
    ROUTES,
    IndexRoute,
    SignInRoute,
    SignUpRoute,
    StartRoute,
    QuizRoute,
    CongratsRoute,
    PaymentRoute,
    BillingRoute,
    PricesRoute,
    ResetRoute,
    ForgotRoute,
    ProfileRoute,
    Router
} from './router';

/*
Keep in mind that order of routes is matter
*/
Router.on({
    ...SignInRoute(ROUTES.SIGNIN),
    ...SignUpRoute(ROUTES.SIGNUP),
    ...StartRoute(ROUTES.START),
    ...QuizRoute(ROUTES.QUIZ),
    ...PricesRoute(ROUTES.PRICES),
    ...CongratsRoute(ROUTES.CONGRATS),
    ...PaymentRoute(ROUTES.PAYMENT),
    ...BillingRoute(ROUTES.BILLING),
    ...ResetRoute(ROUTES.RESET),
    ...ForgotRoute(ROUTES.FORGOT),
    ...ProfileRoute(ROUTES.PROFILE),
    ...IndexRoute(ROUTES.INDEX)
});

Router.notFound(() => {
    Router.navigate(ROUTES.INDEX);
});

// ENTRY POINT
const resolveApp = () => {
    authService.init(() => {
        Router.resolve();
    });
};

document.onload = resolveApp();
